import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Point, PointGroup } from 'angular2-signaturepad';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';
import { InputDrawLicense } from './input-draw-license';
import { ModalContentDrawLicenseComponent } from './modal-content-draw-license.component';

@Component({
  selector: 'app-input-draw-license',
  templateUrl: './input-draw-license.component.html',
  styleUrls: ['./input-draw-license.component.scss']
})
export class InputDrawLicenseComponent implements OnInit, OnDestroy {

  @Input() title: any;
  @Input() labelAdd: any;
  @Input() imageType: '' | 'image/jpeg' | 'image/svg+xml' = '';
  @Output() drawUrl: EventEmitter<string> = new EventEmitter();

  drawLicense: InputDrawLicense = new InputDrawLicense();
  private tempDraw: Array<Point>;
  private subscribeModal: Subscription;

  // for modal
  bsModalRef: BsModalRef;
  private modalOptions: ModalOptions = {
    class: '',
    ignoreBackdropClick: true,
  };

  constructor(
    public modalService: BsModalService
  ) { }

  ngOnInit() {
    this.drawLicense.title = this.title;
    this.drawLicense.imageType = this.imageType;
    this.modalSubscribe();
  }

  ngOnDestroy(): void {
    this.subscribeModal.unsubscribe();
  }

  openDraw() {
    this.modalOptions.initialState = this.drawLicense;
    this.bsModalRef = this.modalService.show(ModalContentDrawLicenseComponent, this.modalOptions);
  }

  private modalSubscribe() {
    this.subscribeModal = this.modalService.onHide.subscribe((val) => {
      if (val === 'ok') {
        this.drawLicense.data = this.bsModalRef ? this.bsModalRef.content.data : [];
        this.drawLicense.dataURL = this.bsModalRef ? this.bsModalRef.content.dataURL : '';
        this.tempDraw = Object.assign([], this.drawLicense.data);
        this.drawUrl.emit(this.drawLicense.dataURL);
      } else if (val === 'close') {
        this.drawLicense.data = Object.assign([], this.tempDraw);
      }
    });
  }
}
